export function formatSalary(value: number, currency: string) {
  if (!value) return null;

  return `${currency.toUpperCase()} ${Intl.NumberFormat().format(value)}`;
}
